module.exports = __webpack_public_path__ + "img/fleetchoice-white.ed6c74b6.svg";